import React, { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import useFetch from "../../../../../services/functions/useFetch";
import CustomAlert from "../../../../CustomAlert";
import snowflake from "../../../../../assets/icons/loading-snowflake.svg";
import { VideoComponent } from "./VideoComponent";
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

// import required modules
import { Pagination, Navigation } from "swiper/modules";

// Use environment variable from .env-file
const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;

// Define the shape of the CardData
interface CardData {
  id: number;
  title: string;
  description: string;
  pic_id: number[];
  vid_id: number[];
}

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function ContentDetail() {
  const query = useQuery();
  const id = query.get("id");

  const pagination = {
    el: ".pagination",
    clickable: true,
    bulletClass: "pagination__bullet",
    bulletActiveClass: "pagination__bullet-active",
  };

  const { data, error, isPending, fetchData } = useFetch<CardData>();

  useEffect(() => {
    fetchData(`/get/exercise/${id}`, "GET", {});
  }, [id]);

  return (
    <>
      {error && <CustomAlert message={error} type="error" />}
      {isPending && (
        <img src={snowflake} alt="loading" className="loading-snowflake" />
      )}
      {data && (
        <>
          <Swiper
            slidesPerView={1}
            spaceBetween={30}
            loop={true}
            pagination={pagination}
            navigation={true}
            modules={[Pagination, Navigation]}
            className="detailedCard__mySwiper"
          >
            {data.vid_id.map((video) => (
              <SwiperSlide key={video}>
                <VideoComponent videoSrc={`${apiBaseUrl}/vid/${video}`} />
              </SwiperSlide>
            ))}
            {data.pic_id.map((image) => (
              <SwiperSlide key={image} onDragStart={(e) => e.preventDefault()}>
                <img src={`${apiBaseUrl}/pic/${image}`} alt="image" />
              </SwiperSlide>
            ))}
          </Swiper>
          <div className="pagination"></div>
          <div className="detailedCard__box">
            <div className="detailedCard__title">{data.title}</div>
            <div className="detailedCard__description">{data.description}</div>
          </div>
        </>
      )}
    </>
  );
}

export default ContentDetail;
